/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'
import CrudIndex from '~/components/CrudIndex'
import { useHookstate } from '@hookstate/core'

// no types required since results are not rendered here
export default function Index() {
  const { translate } = useLang()

  const forceRefresh = useHookstate<boolean>(false)
  const lockFields = useHookstate<boolean>(false)
  const loading = useHookstate<boolean>(false)
  const name = useHookstate<string | null>(null)

  useEffect(() => {
    document.title = translate('Resources - Dispatch System')
  }, [])

  const materialGroupFilter = [
    {
      type: 'name',
      placeholder: 'Name',
      variable: name
    },
  ]

  return (
    <Layout marginLayout={true}>
      <CrudIndex 
        model='material-group' 
        title='Material groups'
        loading={loading}
        lockFields={lockFields.get()}
        clearFilters={() => {
          name.set('')
          forceRefresh.set(!forceRefresh.get())
        }}
        filters={materialGroupFilter}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        disableColumnsFilters
        canView={true}
        showInViewMore={['name', 'created_at']}
        viewTitle='Grupo de material'
      />
    </Layout>
  )
}
